import Header from "../../../Common/Header";
const Home = () => {
  return (
    <>
    <section className="hero_banner ">
      <Header />
      <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center position-relative">
        
        <div className="container position-relative mb-5">
          <div className="row flex-column">
            <div className="col-sm-8 offset-sm-2 col-xl-8 offset-xl-2 text-center">
              <h5 className="text-white fw-bolder headerMargin fs-3tx">
                Coming Soon
              </h5>
              <h3 className="text-white fw-bold fs-1 py-3">
              <i style={{fontSize:"2rem",color:"#fff"}}>Challenge your friends in fantasy MMA, use the data to beat your bookie</i>
              </h3>
              <p className="text-white font-system fs-5 px-10">
              <i style={{fontSize:"2rem",color:"#fff"}}>Who's the REAL expert?</i>
              </p>
            </div>
          </div>
        </div>
        {/* <div className="cu-image-layout position-relative">
          <div className="row justify-content-center">
            <div className="col-10">
              <div className="row justify-content-center">
                <div className="col-xs-5 col-sm-6 col-lg-4">
                  <img
                    className="img-fluid"
                    src="/assets/images/HTP-10.jpg"
                    alt=""
                  />
                </div>
                <div className="col-xs-5 col-sm-6 col-lg-4">
                  <img
                    className="img-fluid"
                    src="/assets/images/HTP-11.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
    </>
  );
};
export default Home;
